export const businessIntelligence = {
  conformity_heatmap: {
    title: "Carte thermique de conformité",
    description: "Carte thermique interactive montrant les niveaux de conformité agrégés pour tous les sites et thèmes",
    loading_error: "Échec du chargement des données de conformité. Veuillez réessayer.",
    stats: {
      total_tasks: "Tâches totales",
      sites_with_data: "Sites avec données",
      themes_with_data: "Thèmes avec données",
    },
    filters: {
      title: "Filtres",
      year: "Année",
      all_years: "Toutes les années",
      site: "Site",
      all_sites: "Tous les sites",
      theme: "Thème",
      all_themes: "Tous les thèmes",
      standard: "Norme",
      all_standards: "Toutes les normes",
      assessment: "Évaluation",
      all_assessments: "Toutes les évaluations",
      clear_all: "Tout effacer",
    },
    legend: {
      does_not_meet: "Ne répond pas",
      partially_meets: "Répond partiellement",
      substantially_meets: "Répond substantiellement",
      fully_meets: "Répond entièrement",
      no_scorable_data: "Aucune donnée évaluable",
    },
    axis_labels: {
      sites: "Sites",
      themes: "Thèmes",
    },
    avg_conformity_level: "Niveau de conformité moyen",
    no_data_message:
      "Aucune donnée disponible pour les filtres sélectionnés. Essayez d'ajuster vos critères de filtre.",
  },
};
